import { components } from '@/utils'

function renderHeaderSlot() {
  if (this.$scopedSlots.header) {
    return this.$scopedSlots.header({
      toggle: this.toggle,
      expanded: this.expanded
    })
  }

  return this.$slots.header
}
function renderHeader(h) {
  return h(
    'div',
    {
      class: `${components['expansion-panel']}__header`,
      on: {
        click: () => {
          if (!this.preventClick) {
            this.toggle()
          }
        }
      }
    },
    [ renderHeaderSlot.call(this) ]
  )
}

function renderBodySlot() {
  if (this.$scopedSlots.default) {
    return this.$scopedSlots.default({
      toggle: this.toggle,
      expanded: this.expanded
    })
  }

  return this.$slots.default
}
function renderBody(h) {
  if (this.expanded) {
    return h(
      'div',
      {
        class: `${components['expansion-panel']}__body`
      },
      [ renderBodySlot.call(this) ]
    )
  }
}

export default function(h) {
  return h(
    'div',
    {
      class: this.$_class,
      on: this.$eventHandlers
    },
    [
      renderHeader.call(this, h),
      renderBody.call(this, h)
    ]
  )
}
